import { render, staticRenderFns } from "./uploadVideoThumb.vue?vue&type=template&id=6f392614&scoped=true"
import script from "./uploadVideoThumb.vue?vue&type=script&lang=js"
export * from "./uploadVideoThumb.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f392614",
  null
  
)

export default component.exports